/**
 * Build-time config, injected by vite.config.ts (`define`). Only what the app needs before it can
 * reach the backend. Everything else comes from GET /api/config (see api/clientConfig.ts).
 */
declare const __API_BASE__: string;
declare const __BUILD_TARGET__: "web" | "ios" | "android";
declare const __COMMIT_SHA__: string;

export const API_BASE: string = typeof __API_BASE__ === "string" ? __API_BASE__ : "/api";
export const BUILD_TARGET = typeof __BUILD_TARGET__ === "string" ? __BUILD_TARGET__ : "web";
export const COMMIT_SHA = typeof __COMMIT_SHA__ === "string" ? __COMMIT_SHA__ : "unknown";
